import Alert from '@material-ui/lab/Alert';
import React from 'react';
import { useGetFeatureAccess } from 'v2/hooks/useGetFeatureAccess';
import { USER_IN_BLACKLIST_ERROR_STATUS } from 'v2/interfaces/featureAccess';

import { useStyles } from './styles';

function BlacklistMessage() {
  const classes = useStyles();

  const featureAccessData = useGetFeatureAccess();
  const transferAccessData = featureAccessData?.transfer;

  if (transferAccessData?.code !== USER_IN_BLACKLIST_ERROR_STATUS) return null;

  return (
    <Alert
      icon={false}
      className={classes.alert}
      severity='warning'
      action={
        <a
          className={classes.actionBtn}
          target='_blank'
          href='https://glpi.eduzz.com/plugins/formcreator/front/formdisplay.php?id=97'
          rel='noreferrer'
        >
          Responder Formulário
        </a>
      }
    >
      <p>
        Nossos meios de pagamento detectaram transações que podem trazer prejuízos financeiros à sua conta. Responda o Formulário o quanto antes para
        que possamos te auxiliar da melhor forma. Enquanto analisamos, as funções &quot;Transferir&quot; e &quot;Antecipar&quot; ficarão bloqueadas.{' '}
        <a
          className={classes.knowMoreLink}
          target='_blank'
          href='https://ajuda.eduzz.com/hc/pt-br/articles/6734291431067-Estou-com-problemas-nas-minhas-transfer%C3%AAncias-e-agora'
          rel='noreferrer'
        >
          Saiba mais
        </a>
      </p>
    </Alert>
  );
}

export default BlacklistMessage;
